import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

export type ShopLocatorItemMode = "button" | "selected" | "none";

@Component({
    selector: "h-shop-locator-navigation-item",
    templateUrl: "./shop-locator-navigation-item.component.html",
    styleUrls: ["./shop-locator-navigation-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ShopLocatorNavigationItemComponent {
    @Input()
    public isActive: boolean = false;

    @Input()
    public title?: string = "";
}
